function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16 2H8C4 2 2 4 2 8V21C2 21.55 2.45 22 3 22H16C20 22 22 20 22 16V8C22 4 20 2 16 2Z",
  fill: "#727272"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.5514 7.45995C15.2914 6.19995 14.0714 6.16995 12.7814 7.45995L11.9914 8.24995C11.9214 8.31995 11.9014 8.41995 11.9214 8.50995C12.4114 10.2299 13.7814 11.5999 15.5014 12.0899C15.5214 12.0999 15.5514 12.0999 15.5814 12.0999C15.6514 12.0999 15.7214 12.0699 15.7714 12.0199L16.5514 11.2399C17.1914 10.5999 17.5014 9.98994 17.5014 9.36995C17.5014 8.71994 17.1914 8.09995 16.5514 7.45995Z",
  fill: "#B4B4B4"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.3404 12.6699C14.1504 12.5799 13.9704 12.4899 13.8004 12.3799C13.6604 12.2999 13.5204 12.2099 13.3904 12.1099C13.2804 12.0399 13.1504 11.9399 13.0204 11.8299C13.0004 11.8199 12.9604 11.7899 12.9104 11.7299C12.7004 11.5499 12.4604 11.3099 12.2404 11.0599C12.2204 11.0499 12.1904 10.9999 12.1504 10.9399C12.0804 10.8599 11.9804 10.7299 11.8804 10.5899C11.8004 10.4899 11.7104 10.3499 11.6304 10.2099C11.5304 10.0399 11.4304 9.85987 11.3504 9.67987C11.2604 9.47987 11.1904 9.29987 11.1204 9.11987L7.35044 12.8899C7.10044 13.1399 6.87044 13.5999 6.82044 13.9399L6.53043 16.0199C6.46043 16.4599 6.59042 16.8699 6.86042 17.1499C7.09042 17.3799 7.41044 17.4999 7.76044 17.4999C7.84044 17.4999 7.91042 17.4899 7.99042 17.4799L10.0704 17.1899C10.4104 17.1399 10.8704 16.9099 11.1204 16.6599L14.8904 12.8899C14.7104 12.8199 14.5304 12.7499 14.3404 12.6699Z",
  fill: "#B4B4B4"
});

var SvgDatlenhLight = function SvgDatlenhLight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDatlenhLight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/datlenh_light.f71936fb.svg";
export { ForwardRef as ReactComponent };